import { sleep } from "@/plugins/helpers";

const state = {
  click: false,
  skip: false,
};

const getters = {
  click(state) {
    return state.click;
  },
  skip() {
    return state.skip;
  },
};

const mutations = {
  async click(state) {
    state.click = true;
    await sleep(50);
    state.click = false;
  },
  async skip(state) {
    state.skip = true;
    await sleep(50);
    state.skip = false;
  },
};

export default {
  namespaced: "sfx",
  state,
  mutations,
  getters,
};
